
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import PageBase from "../../PageBase.vue";
import RealEstateFsSurvey from "./RealEstateFSSurvey.vue";

import { stepInfoType, stepResultInfoType } from "@/types/Application";

@Component({
    components:{
      RealEstateFsSurvey,
      PageBase
    }
})
export default class RealEstateFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('realEstateData')
    realEstateDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {realEstateFSSurvey: this.getRealEstateResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    realEstateData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.realEstateFSSurvey?.data) {
            this.realEstateData = this.step.result.realEstateFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.realEstateData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('real-estate-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(realEstateValue) {
        const currentIndexValue = this.realEstateData?.length > 0 ? this.realEstateData[this.realEstateData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newRealEstate = { ...realEstateValue, id };

        this.realEstateData = this.realEstateData? [...this.realEstateData, newRealEstate]:[newRealEstate];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.realEstateData = this.realEstateData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.realEstateData = this.realEstateData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.realEstateData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.realEstateData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{realEstateFSSurvey: this.getRealEstateResults()}})       
    }
   
    public getRealEstateResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.realEstateData)
            for(const realEstate of this.realEstateData)
            {
                questionResults.push({name:'realEstateFSSurvey', value: this.getRealEstateInfo(realEstate), title:'Real Estate '+realEstate.id +' Information', inputType:''})
            }

        return {data: this.realEstateData, questions:questionResults, pageName:'Real Estate', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getRealEstateInfo(realEstate){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+realEstate.realEstateDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+realEstate.realEstateValue);
        return resultString
    }

}
